export default __webpack_public_path__ + "206be56d8d8538dd98de4c161ea4e7fc.png";